import Vue from 'vue'
import Router from 'vue-router'
import _ from 'lodash'
import * as routes from '../routes/**/*.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '',
  routes:
    _.concat([
      // Defined Routes
      { path: '/', redirect: '/assignments' },
    ],
    // Autoload from ./routes
    _.map(routes, (route) => {
      return _.assign({
        name: route.name.toLowerCase(),
        component: route
      }, route.routeConfig)
    }))
  ,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/initializers/router.js